import LaunchRealTimeActivity from '@/pages/ClassDetail/ClassTasks/LaunchRealTimeActivity/LaunchRealTimeActivity';
import Button from '@/shared/Button/Button';
import LiveTag from '@/shared/LiveTag/LiveTag';
import useSortImagesActivity from './useSortImageButtons.hook';
import SortImagesExtendedDescription from './SortImagesExtendedDescription/SortImagesExtendedDescription';

export default function SortImagesButtons({ activity }) {
  const { state, actions } = useSortImagesActivity({
    activity,
  });
  return (
    <>
      <Button
        onClick={() => actions.setSelectedAction('showExtendedDescription')}
      >
        What is this activity about?
      </Button>

      {state.canLaunch ? (
        <Button
          type="primary"
          onClick={() => actions.setSelectedAction('start')}
        >
          Start <LiveTag marginLeft /> task
        </Button>
      ) : null}

      {state.selectedAction
        ? {
            start: (
              <LaunchRealTimeActivity
                activityId={activity.id}
                onActionCancelled={actions.onActionClose}
              />
            ),
            showExtendedDescription: (
              <SortImagesExtendedDescription
                activity={activity}
                onClose={actions.onActionClose}
              />
            ),
          }[state.selectedAction]
        : null}
    </>
  );
}
